import { Component, ViewChild } from "@angular/core";
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { EmitType } from '@syncfusion/ej2-base';

@Component({
    selector: 'footer-bar',
    templateUrl: './footer.component.html',
})
export class Footer {

    today = Date.now();

    /* Modal Dialogs --------------------------------------------------------------------------------------------------------------- */

    // The Dialog shows within the target element.
    public targetElement: HTMLElement;

    // Sets the Dialog to hidden on page load
    public visible: Boolean = false;

    // Shows the close icon
    public showCloseIcon: boolean = true;

    // Sample level code to hide the Dialog when click the Dialog overlay
    public onOverlayClick: EmitType<object> = () => {
        this.showPrivacyPolicyDialog.hide();
    }

    @ViewChild('showPrivacyPolicyDialog', { static: false }) public showPrivacyPolicyDialog: DialogComponent;

    // Call the show method to open the Dialog
    public showPrivacyDialog = function (event: any): void {
        this.showPrivacyPolicyDialog.show();
    }

    // Hide the Dialog when click the footer button.
    public hidePrivacyDialog: EmitType<object> = () => {
        this.showPrivacyPolicyDialog.hide();
    }

}
